import { render, staticRenderFns } from "./WyseSelect.vue?vue&type=template&id=05d3c7e5&scoped=true&"
import script from "./WyseSelect.vue?vue&type=script&lang=js&"
export * from "./WyseSelect.vue?vue&type=script&lang=js&"
import style0 from "./WyseSelect.vue?vue&type=style&index=0&id=05d3c7e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3c7e5",
  null
  
)

export default component.exports